export default __webpack_public_path__ + "static/media/Elec13.c722f5fb.png";